const STORAGE_KEY = 'pois'

export interface POI {
    id: string
    name: string
    icon: string
    lat: number
    lon: number
}

export function loadPois(): POI[] {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
    }
    catch {
        return []
    }
}

export function savePois(pois: POI[]): void {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(pois))
}

export function addPoi(poi: Omit<POI, 'id'>): POI {
    const pois = loadPois()
    const newPoi: POI = { ...poi, id: crypto.randomUUID() }
    pois.push(newPoi)
    savePois(pois)
    return newPoi
}

export function updatePoi(id: string, updates: Partial<Omit<POI, 'id'>>): void {
    const pois = loadPois()
    const idx = pois.findIndex(p => p.id === id)
    if (idx >= 0) {
        pois[idx] = { ...pois[idx], ...updates }
        savePois(pois)
    }
}

export function deletePoi(id: string): void {
    const pois = loadPois().filter(p => p.id !== id)
    savePois(pois)
}

export function getFavourites(): POI[] {
    return loadPois()
}
